import DesignParameters from './DesignParameters';

export default DesignParameters;
